import { Component } from '@angular/core';
import { AuthLoginService } from 'src/app/pages/login/services/auth-login.service';
import { DialogComponent } from '../dialog/dialog.component';
import { AgendaService } from './agenda.service';

@Component({
  selector: 'app-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.css'],
})
export class AgendaComponent {
  constructor(
    private readonly service: AgendaService,
    private readonly auth: AuthLoginService
  ) {}

  visible = false;

  title!: string;
  desc!: string;

  desde!: string;
  hasta!: string;

  color: string = '#15FF00';

  recordatorio: string[] = [];
  selectedRecordatorio!: string;

  general = false;

  isProyectos = false;

  rec!: string;
  showRec = false;
  async ngAfterViewInit() {
    const userState = await this.auth.returnUserInfoV2('LOADED');

    if (!userState) return;
    const { user } = userState;

    this.isProyectos =
      user?.lob?.some((l) => l.name === 'Proyectos') || user?.superuser!;
      
    this.recordatorio = [
      'Sin recordatorio',
      '1 día antes',
      '2 días antes',
      '1 semana antes',
      'Personalizado',
    ];
    this.selectedRecordatorio = 'Sin recordatorio';
  }

  mostrar() {
    this.showRec = this.selectedRecordatorio === 'Personalizado';
  }

  hide() {
    this.title = '';
    this.desc = '';
    this.desde = '';
    this.hasta = '';
    this.color = '';
    this.selectedRecordatorio = 'Sin recordatorio';
    this.rec = '';
    this.showRec = false;
    this.general = false;
  }

  onInsert(dialog: DialogComponent) {
    if (
      !this.allDay &&
      new Date(this.desde).getTime() > new Date(this.hasta).getTime()
    ) {
      dialog.stop(
        'La fecha de inicio, no puede ser menor que la fecha de fin',
        'Error de carga',
        () => {},
        true
      );
    } else {
      if (
        (this.title && this.desc && this.desde && this.allDay) ||
        (this.title && this.desc && this.desde && !this.allDay && this.hasta)
      ) {
        dialog.confirm(
          '¿Esta seguro de insertar el nuevo evento?',
          'Confirmación de carga',
          () => {
            this.insert(dialog);
          }
        );
      } else {
        dialog.stop(
          'Falta completar los campos',
          'Error de carga',
          () => {},
          true
        );
      }
    }
  }

  async insert(dialog: DialogComponent) {
    dialog.start();
    const userState = await this.auth.returnUserInfoV2('PARTIAL');

    if (!userState) return;
    const { user } = userState;

    const data: any = {
      titulo: this.title,
      descripcion: this.desc,
      inicio: this.desde,
      fin: this.allDay ? null : this.hasta,
      opcion_recordatorio: this.selectedRecordatorio,
      recordatorio: this.addDays(),
      color: this.color,
      id_usuario: user,
      id_lob: this.general ? 'c08dac93-7267-11ee-95da-e86a649855cb' : null,
    };

    if (this.general) {
      this.service.insertAgendaGral(data).subscribe({
        next: (data) => {
          dialog.stop(
            'Recordatorio agendado con éxito',
            'Confirmación de carga',
            () => {
              this.visible = false;
            }
          );
        },
        error: (e) => {
          dialog.stop(
            'Error al realizar la carga',
            'Error de carga',
            () => {},
            true
          );
        },
      });
    } else {
      this.service.insertAgenda(data).subscribe({
        next: (data) => {
          dialog.stop(
            'Recordatorio agendado con éxito',
            'Confirmación de carga',
            () => {
              this.visible = false;
            }
          );
        },
        error: (e) => {
          dialog.stop(
            'Error al realizar la carga',
            'Error de carga',
            () => {},
            true
          );
        },
      });
    }
  }

  addDays() {
    switch (this.selectedRecordatorio) {
      case 'Personalizado': {
        return new Date(this.rec);
      }
      case '1 día antes': {
        const date = new Date(this.desde);
        date.setDate(date.getDate() - 1);
        return date;
      }
      case '2 días antes': {
        const date = new Date(this.desde);
        date.setDate(date.getDate() - 2);
        return date;
      }
      case '1 semana antes': {
        const date = new Date(this.desde);
        date.setDate(date.getDate() - 7);
        return date;
      }
      default: {
        return null;
      }
    }
  }

  allDay = false;
}
